var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "32px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7DECE",
    d: "M15 22v6a3 3 0 1 0 6 0v-6h-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4289C1",
    d: "M27 27H9a4 4 0 0 0-4 4v5h26v-5a4 4 0 0 0-4-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A6797",
    d: "M26 32h1v4h-1zM9 32h1v4H9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7DECE",
    d: "M15 22v6a3 3 0 1 0 6 0v-6h-6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7DECE",
    d: "M9 5.938V17c0 4.971 4.029 9 9 9s9-4.029 9-9V6.25L9 5.938z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7DECE",
    d: "M10.847 13.715c0 1.58-.8 2.861-1.788 2.861s-1.788-1.281-1.788-2.861c0-1.58.801-2.861 1.788-2.861s1.788 1.281 1.788 2.861zm17.882 0c0 1.58-.8 2.861-1.788 2.861s-1.788-1.281-1.788-2.861c0-1.58.8-2.861 1.788-2.861s1.788 1.281 1.788 2.861z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B0200",
    d: "M18 .823c-7.019 0-10.139 4.684-10.139 8.588c0 3.903 1.343 4.986 1.56 3.903c.78-3.903 3.12-5.101 3.12-5.101c4.68 3.904 3.9.781 3.9.781c4.679 4.684 2.34 0 2.34 0c1.56 1.562 6.239 1.562 6.239 1.562s.78 1.198 1.559 2.759c.78 1.562 1.56 0 1.56-3.903c0-3.905-3.9-8.589-10.139-8.589z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#C1694F",
    cx: 18,
    cy: 22,
    rx: 2,
    ry: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M19 19.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 0 1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0AA94",
    d: "M28.613 4.397L26.66 2.444l-.525.619l-3.5-1.271v1.58l-2.63.607c-.603.141-.98.743-.841 1.347c.138.604.742.98 1.345.841l3.579-.825l1.79 1.791c.3.3.802.581 1.329.751l.678 5.586s0 .875.875.875s.875-.875.875-.875v-7l-1.022-2.073z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7DECE",
    d: "M28.957 4.053L27.004 2.1L26.479 0h-3.5v3.027l-2.63.607c-.603.141-.98.743-.841 1.347c.138.604.742.98 1.345.841l3.579-.825l1.79 1.791c.3.3.802.581 1.329.751l.678 5.586s0 .875.875.875s.875-.875.875-.875v-7l-1.022-2.072z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0AA94",
    d: "M7.387 4.397L9.34 2.444l.525.619l3.5-1.396v1.705l2.63.607c.603.141.98.743.841 1.347c-.138.604-.742.98-1.345.841l-3.579-.825l-1.79 1.791c-.3.3-.802.581-1.329.751l-.678 5.586s0 .875-.875.875s-.875-.875-.875-.875v-7l1.022-2.073z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7DECE",
    d: "M7.043 4.053L8.996 2.1L9.521 0h3.5v3.027l2.63.607c.603.141.98.743.841 1.347c-.138.604-.742.98-1.345.841l-3.579-.825l-1.79 1.791c-.3.3-.802.581-1.329.751l-.678 5.586s0 .875-.875.875s-.875-.875-.875-.875v-7l1.022-2.072z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.906 15.056a.25.25 0 0 0-.305-.007c-.006.005-.63.451-1.851.451c-1.22 0-1.845-.446-1.85-.45a.25.25 0 0 0-.379.301c.03.068.751 1.649 2.229 1.649c1.479 0 2.199-1.581 2.229-1.648a.249.249 0 0 0-.073-.296zm-7.5 0a.25.25 0 0 0-.305-.007c-.006.005-.63.451-1.851.451c-1.22 0-1.845-.446-1.85-.45a.25.25 0 0 0-.379.301c.03.068.751 1.649 2.229 1.649c1.479 0 2.199-1.581 2.229-1.648a.25.25 0 0 0-.073-.296z",
    fill: "#662113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpa);
export default __webpack_public_path__ + "static/media/spa.8a2de28443ce707e772e00dd0e7b2cfb.svg";
export { ForwardRef as ReactComponent };